module.exports = __webpack_public_path__ + "static/media/start.ffe8ebcb.svg";